import script from "./PolicyList.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyList.vue?vue&type=script&setup=true&lang=js"

import "./PolicyList.vue?vue&type=style&index=0&id=f71fe034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f71fe034"]])

export default __exports__